import moment from 'moment'

export const getCalendar = function (date, events, dayStatus) {
  let startDate = moment(date).startOf('month').startOf('isoWeek')
  let endDate = moment(date).endOf('month').endOf('isoWeek').add(1, 'd')
  let arrays = []
  let currentArray = []
  let planned = 0
  let done = 0
  let totalPlanned = 0
  let totalDone = 0
  let totalPlannedCount = 0
  let totalDoneCount = 0
  let totalMonthPlanned = 0
  let totalMonthDone = 0
  let totalMonthPlannedCount = 0
  let totalMonthDoneCount = 0
  for (let m = moment(startDate); m.isBefore(endDate); m.add(1, 'd')) {
    let day = {date: moment(m), otherMonth: !m.isSame(date, 'month'), events: [], isOpen: !!dayStatus[m.format('YYYY-MM-DD')]}
    for (let ev of events) {
      if (m.isSame(ev.datetime, 'day')) {
        if (ev.type === 'race') {
          day.events = []
        }
        day.events.push(ev)
        if (ev.type !== 'activity') {
          // aktywności nie wchodzą w zaplanowane
          planned += ev.planned
          totalPlannedCount += 1
          if (!day.otherMonth) {
            totalMonthPlannedCount += 1
          }
        }
        done += ev.done
        if (ev.done !== 0 && ev.type !== 'activity') {
          totalDoneCount += 1
          if (!day.otherMonth) {
            totalMonthDoneCount += 1
          }
        }
        if (ev.type !== 'activity') {
          totalPlanned += ev.planned
        }
        totalDone += ev.done
        if (!day.otherMonth) {
          if (ev.type !== 'activity') {
            totalMonthPlanned += ev.planned
          }
          totalMonthDone += ev.done
        }
      }
    }
    currentArray.push(day)
    if (m.day() === 0) {
      arrays.push({date: currentArray[0].date, 'days': currentArray, 'totalPlanned': Math.round(planned), 'totalDone': Math.round(done)})
      currentArray = []
      planned = 0
      done = 0
    }
  }
  return {
    totalPlanned: Math.round(totalPlanned),
    totalDone: Math.round(totalDone),
    totalPlannedCount,
    totalDoneCount,
    totalMonthPlanned: Math.round(totalMonthPlanned),
    totalMonthDone: Math.round(totalMonthDone),
    totalMonthPlannedCount,
    totalMonthDoneCount,
    weeks: arrays
  }
}



// WEBPACK FOOTER //
// ./src/utils/calendar.js